import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetaItemProps {
  icon: LucideIcon;
  children: React.ReactNode;
  size?: number;
}

/** Icon + label row used for location, period and email throughout the site. */
const MetaItem: React.FC<MetaItemProps> = ({ icon: Icon, children, size = 16 }) => (
  <div className="flex items-center gap-2 text-dark-muted text-sm">
    <Icon size={size} className="flex-shrink-0" />
    <span>{children}</span>
  </div>
);

export default MetaItem;
